import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { formatCurrency } from '../utils';
import { addToCart } from '../redux/actions';
import { Button, Select, Modal } from '.';

export default function ProductModal({
  open,
  setOpen,
  product,
  disableCart,
  handleClose,
}) {
  const [quantity, setQuantity] = useState(1);

  const dispatch = useDispatch();

  const addItemToCart = () => {
    dispatch(addToCart(product, quantity));
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      handleClose={handleClose}
      product={product}
    >
      <div className="w-full grid grid-cols-1 gap-y-0 gap-x-0 items-start sm:grid-cols-12 lg:gap-x-0 p-5">
        <div className="aspect-w-2 aspect-h-3 rounded-lg bg-gray-100 overflow-hidden sm:col-span-4 lg:col-span-5 h-96 p-8 m-auto">
          <img
            src={product?.imageSrc}
            alt={product?.name}
            className="object-center object-cover h-full m-auto"
          />
        </div>
        <div className="sm:col-span-8 lg:col-span-7 p-8 h-full">
          <h2 className="text-xl font-bold text-gray-900 sm:pr-12">
            {product.name}
          </h2>

          <section aria-labelledby="information-heading" className="mt-2">
            <h3 id="information-heading" className="sr-only">
              Product information
            </h3>

            <p className="text-base text-gray-500 font-bold">
              {formatCurrency(product.price)}
            </p>
          </section>

          {!disableCart && (
            <section>
              <div className="mt-10">
                <div className="flex items-center justify-between">
                  <h4 className="text-base text-gray-900 font-medium">
                    Quantity
                  </h4>
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <Select
                    handleOnChange={(e) =>
                      setQuantity(parseInt(e.target.value))
                    }
                    optionList={[...Array(10)].map((_, ind) => ({
                      name: ind + 1,
                      value: ind + 1,
                    }))}
                  />
                </div>
              </div>
            </section>
          )}

          <section aria-labelledby="description-heading" className="mt-10">
            <div className="mt-10">
              <div className="flex items-center justify-between">
                <h4 className="text-base text-gray-900 font-medium">
                  Description
                </h4>
              </div>
              <p className="text-gray-500 text-sm mt-3">
                {product.description}
              </p>
            </div>
          </section>
          {!disableCart && (
            <section>
              <div className="mt-10">
                <Button label="Add to cart" handleClick={addItemToCart} />
              </div>
            </section>
          )}
        </div>
      </div>
    </Modal>
  );
}
